import * as api from 'services/api';
import { addError } from 'actions/error';

export const getPlatformsFilterOptions = () => (dispatch) =>
  api
    .get('education/institutions/programs/filter-options', 'GET_PLATFORMS_FILTERS_INFO', dispatch)
    .catch((error) => {
      dispatch(addError(new Error('GET_PLATFORMS_FILTERS_INFO_ERROR')));
      return {};
    });

export const getPlatformById = (id) => (dispatch) =>
  api.get(`education/platforms/${id}`, 'GET_PLATFORM_BY_ID', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_PLATFORM_BY_ID_ERROR')));
    return null;
  });
